import { Device, Market, ServiceProvider, TechnicianStatus, WorkModel } from "./Common";

export const UTILS_DEPENDENCIES = {
	MARKETS: 'markets' as const,
	DEVICES: 'devices' as const,
	TECHNICIAN_STATUSES: 'technician_statuses' as const,
	WORK_MODELS: 'work_models' as const,
	SERVICE_PROVIDERS: 'service_providers' as const
}
export interface UtilsDependencies {
	[UTILS_DEPENDENCIES.MARKETS]: Market[] | null,
	[UTILS_DEPENDENCIES.DEVICES]: Device[] | null
	[UTILS_DEPENDENCIES.TECHNICIAN_STATUSES]: TechnicianStatus[] | null,
	[UTILS_DEPENDENCIES.WORK_MODELS]: WorkModel[] | null,
	[UTILS_DEPENDENCIES.SERVICE_PROVIDERS]: ServiceProvider[] | null
}

export interface UtilsState {
	data: UtilsDependencies
}

export interface BEDevice extends Device{
	device_family_category_id: number,
	device_family_category: string
}
